import Badge from "../Badge"

export const GroupCell = (props) => {
  return (
    <td>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          overflow: 'auto',
          whiteSpace: 'nowrap'
        }}
      >
        {props.groups && props.groups.map(group => (
          <Badge
            key={group.id}
            style={{
              padding: '5px 10px',
              fontSize: '10px',
            }}
            data={group.name}
          />
        ))}
      </div>
    </td>
  )
}